module.exports = __webpack_public_path__ + "static/img/empleadorhome-1680x1050.f0fd665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/empleador/home/empleadorhome-1680x1050.png
// module id = xpRH
// module chunks = 47